import styled from '@emotion/styled';

export const Container = styled.a<{ disabled?: boolean }>(({ disabled }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? '0.3' : '1',
  };
});
